'use strict';

var Sugar = require('sugar-core');

require('./build/buildRelativeAliasesCall');

module.exports = Sugar.Date.isYesterday;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/isYesterday.js
// module id = 567
// module chunks = 0